import { WorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { WorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDisclosure } from '@/hooks';
import { Button } from 'antd';
import React from 'react';

const WorkOrderEtiquetteModal = React.lazy(
  () => import('./WorkOrderEtiquetteModal'),
);

interface Props {
  workOrder?: WorkOrder;
  complement?: WorkOrderComplement;
}

export default function WorkOrderEtiquetteButton({
  workOrder,
  complement,
}: Props) {
  const [opened, action] = useDisclosure();

  return (
    <>
      <Button block onClick={action.open}>
        Gerar Etiqueta
      </Button>

      {opened && (
        <React.Suspense fallback={<></>}>
          <WorkOrderEtiquetteModal
            open={opened}
            onCancel={action.close}
            workOrder={workOrder}
            complement={complement}
          />
        </React.Suspense>
      )}
    </>
  );
}
